export default {
  placeholder: 'Select weekdays',
};
